/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { Modal, Form, Button, FloatingLabel } from 'react-bootstrap';
import { PlusIcon } from '@heroicons/react/solid';

export interface IKanbanCopyModalProps {
    type: 'card' | 'list';
    cardType?: string;
    show?: boolean;
    lists?: any;
    title: string;
    listId: string;
    onHide?(): void;
    onSubmit?(payload: any): void;
}

export const KanbanCopyModal = (props: IKanbanCopyModalProps) => {
    const { type, lists, show, ...otherProps } = props;
    const [title, setTitle] = useState(props.title ?? '');
    const [listId, setListId] = useState(props.listId ?? '');
    const lCardType = props.cardType?.toLowerCase();
    const pCardType = `${lCardType}s`;

    const onHide = () => {
        props.onHide && props.onHide();
    };

    const onSubmit = () => {
        const payload = { ...otherProps, title, listId };
        return props.onSubmit && props.onSubmit(payload);
    };

    return (
        <>
            <Modal as={Modal.Dialog} centered show={show} onHide={onHide}>
                <Form className="modal-content p-3">
                    <Modal.Header className="pb-0 border-0">
                        <Modal.Title className="fw-normal">
                            {`Copy ${lCardType}`}
                        </Modal.Title>
                        <Button variant="close" onClick={onHide} />
                    </Modal.Header>
                    <Modal.Body className="pb-0">
                        <Form.Group id="title" className="mb-3">
                            <S.FormControl
                                fontScale={fontScale}
                                autoFocus
                                type="text"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                onFocus={(e) => e.target.select()}
                            />
                        </Form.Group>
                        {type === 'card' && (
                            <FloatingLabel
                                id="list"
                                label="Copy to list.."
                                className="mb-3"
                            >
                                <Form.Select
                                    value={listId}
                                    onChange={(e) => setListId(e.target.value)}
                                >
                                    {lists.map((l: any) => (
                                        <option
                                            value={l.id}
                                            key={`copy-card-option-${l.id}`}
                                        >
                                            {l.title}
                                        </option>
                                    ))}
                                </Form.Select>
                            </FloatingLabel>
                        )}
                    </Modal.Body>
                    <Modal.Footer className="justify-content-start border-0 pt-0">
                        <Button
                            variant="secondary"
                            className="d-inline-flex align-items-center"
                            onClick={onSubmit}
                        >
                            <PlusIcon className="icon icon-xs me-2" />
                            {`Create ${lCardType}`}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    );
};

KanbanCopyModal.defaultProps = {
    cardType: 'Card',
    type: 'card',
    show: false,
    lists: [],
};
